var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    config           = require("app/config"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind"),
    onHyperlinkTap   = require("app/utils/onHyperlinkTap"),
    quickMacroize    = require("enyo/macroize").quickMacroize;

require("app/theme/IconButton--neutral.less");

module.exports = kind(/** @lends  app.ProfilePage.ChangePaymentButton.prototype */ {

    /**
     * @private
     */
    name: "app.ProfilePage.ChangePaymentButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-profile-page-change-payment-button",

    /**
     * @private
     */
    mixins: [
        HyperLinkSupport
    ],

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: "neutral",

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type  {?string}
     * @public
     */
    icon: icons["app.ProfilePage.ChangePaymentButton"],

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.authService.user", this.update);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var authService      = this.app.$.authService,
            i18nService      = this.app.$.i18nService,
            paymentMethod    = get(authService, "user.payment_method", false),
            userStatus       = get(authService, "user.status", null),
            language         = i18nService.get("language"),
            changePaymentUrl = get(config, "changePaymentUrl." + language, null);

        this.set("caption", i18nService.getString("app.ProfilePage.ChangePaymentButton.caption"));
        this.set("tooltip", i18nService.getString("app.ProfilePage.ChangePaymentButton.tooltip"));

        if (get(config, "profile.allowSubscriptionModification", true)
            && authService.isLoggedIn === 1
            && paymentMethod
            && paymentMethod !== "none"
            && (
                userStatus === "subscribed"
                || userStatus === "unsubscribed"
            )
        ) {
            this.show();
            this.set("href", changePaymentUrl ? quickMacroize(changePaymentUrl, {
                successUrl: encodeURIComponent(window.location)
            }) : null);
        }
        else {
            this.hide();
            this.set("href", null);
        }
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    tap: function() {
        return onHyperlinkTap.call(this, this);
    }

});
